import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function Header({ type }) {
  const { t } = useTranslation()
  return (
    <Grid container justifyContent="space-between" pb={2} pl={2} pr={2} pt={2}>
      <Grid item xs={1.4}></Grid>
      <Grid item xs={1.8}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontWeight: 600 }}>{t('CART.NAME')}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={1.4}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontWeight: 600 }}>{t('CART.MERCHANT')}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={1.4}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontWeight: 600 }}>{t('CART.PRICES')}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={1.2}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontWeight: 600 }}>{t('CART.IN_STOCK')}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={0.8}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontWeight: 600 }}>{t('CART.POINTS')}</Typography>
        </Grid>
      </Grid>

      {VOUCHER_TYPE.PREMIUM === type && (
        <Grid item xs={1.4}>
          <Grid container justifyContent="center">
            <Typography sx={{ fontWeight: 600 }}>{t('CART.CODE_AMOUNT')}</Typography>
          </Grid>
        </Grid>
      )}

      {VOUCHER_TYPE.PREMIUM === type && (
        <Grid item xs={1.8}>
          <Grid container justifyContent="center">
            <Typography sx={{ fontWeight: 600 }}>{t('CART.ESTIMATE_COST')}</Typography>
          </Grid>
        </Grid>
      )}

      <Grid item xs={0.8}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontWeight: 600 }}>{t('CART.ACTION')}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
